import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "h-full bg-curious-blue-100 px-5 py-2 text-gray-600 text-sm w-full"
}
const _hoisted_2 = { class: "flex h-full" }
const _hoisted_3 = { class: "font-semibold flex items-center truncate" }
const _hoisted_4 = { class: "font-thin" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "font-semibold" }
const _hoisted_7 = { class: "font-thin" }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "font-semibold" }
const _hoisted_10 = { class: "font-thin" }
const _hoisted_11 = { class: "h-full w-full flex flex-1 justify-center items-center bg-gray-100 pb-10" }
const _hoisted_12 = { class: "w-full h-full mt-3 device-preview" }
const _hoisted_13 = { class: "space-x-1 flex items-center justify-center" }
const _hoisted_14 = { class: "space-x-1.5 flex items-center justify-center" }
const _hoisted_15 = { class: "space-x-1.5 flex items-center justify-center" }

import { computed, ref } from 'vue'

import { UILoading, UIIcon, UISpinner } from '@gohighlevel/ghl-canvas'
import {
  Monitor03Icon,
  Tablet01Icon,
  Phone02Icon,
} from '@gohighlevel/ghl-icons/24/outline'
import {
  UITabs,
  UITabPane,
  UIContentWrap,
  UITextMdMedium,
  UITextSmMedium,
} from '@gohighlevel/ghl-ui'
import Devices from './Devices.vue'
import '../../assets/devices.min.css'


export default /*#__PURE__*/_defineComponent({
  __name: 'DevicePreview',
  props: {
  fromAddress: {
    type: String,
    required: false,
    default: '',
  },
  subjectLine: {
    type: String,
    required: false,
    default: '',
  },
  previewHtml: {
    type: String,
    required: true,
  },
  contacts: {
    type: Array,
    required: false,
  },
  showRecipientInfo: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  setup(__props) {

const props = __props

const emailPreviewList = computed(() => {
  let contacts = [] as Array<string>
  if (props.contacts) {
    contacts = JSON.parse(JSON.stringify(props.contacts))
    return contacts
      .splice(0, 3)
      .map((x: any) => x.email)
      .join(', ')
  }
  return contacts
})

const selectedDevice = ref('macbook')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.showRecipientInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, [
              _createTextVNode("To:   "),
              _createElementVNode("span", _hoisted_4, _toDisplayString(emailPreviewList.value), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createTextVNode("From: "),
              _createElementVNode("span", _hoisted_7, _toDisplayString(__props.fromAddress), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, [
              _createTextVNode(_toDisplayString(`${_ctx.$t('common.subject')}`) + " ", 1 /* TEXT */),
              _createElementVNode("span", _hoisted_10, _toDisplayString(__props.subjectLine), 1 /* TEXT */)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_unref(UITabs), { type: "segment" }, {
          default: _withCtx(() => [
            _createVNode(_unref(UITabPane), {
              name: "macbook",
              tab: "Macbook"
            }, {
              tab: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_unref(Monitor03Icon), { class: "w-5 h-5 mr-1" }),
                  _createVNode(_unref(UITextMdMedium), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.desktop')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(Devices, {
                  device: 'macbook',
                  html: __props.previewHtml
                }, null, 8 /* PROPS */, ["html"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_unref(UITabPane), {
              name: "ipad",
              tab: "Ipad"
            }, {
              tab: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_unref(Tablet01Icon), { class: "w-5 h-5 mr-1" }),
                  _createVNode(_unref(UITextMdMedium), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.tablet')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(Devices, {
                  device: 'ipad',
                  html: __props.previewHtml
                }, null, 8 /* PROPS */, ["html"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_unref(UITabPane), {
              name: "iphone-x",
              tab: "Iphone-x"
            }, {
              tab: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_unref(Phone02Icon), { class: "w-5 h-5 mr-1" }),
                  _createVNode(_unref(UITextMdMedium), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.mobile')), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(Devices, {
                  device: 'iphone-x',
                  html: __props.previewHtml
                }, null, 8 /* PROPS */, ["html"])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})